var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSliderPreviousIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 56,
    viewBox: "0 0 55 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1403_1065)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.5,
    cy: 27.7848,
    rx: 23.5,
    ry: 23.7848,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5 27.7848C49.5 40.1095 39.6333 50.0697 27.5 50.0697C15.3667 50.0697 5.5 40.1095 5.5 27.7848C5.5 15.4602 15.3667 5.5 27.5 5.5C39.6333 5.5 49.5 15.4602 49.5 27.7848Z",
    stroke: "#006AB3",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3408 37.9999C31.1273 38.0006 30.9164 37.9535 30.7235 37.8621C30.5307 37.7706 30.3608 37.6371 30.2263 37.4714L23.325 28.9008C23.1149 28.6452 23 28.3246 23 27.9937C23 27.6628 23.1149 27.3422 23.325 27.0866L30.4692 18.516C30.7117 18.2243 31.0602 18.0409 31.438 18.006C31.8159 17.9712 32.192 18.0879 32.4838 18.3303C32.7756 18.5728 32.9591 18.9212 32.994 19.2989C33.0288 19.6766 32.9121 20.0527 32.6696 20.3444L26.2827 28.0008L32.4553 35.6573C32.63 35.8669 32.741 36.1223 32.7751 36.393C32.8092 36.6638 32.765 36.9386 32.6478 37.1851C32.5305 37.4315 32.3451 37.6392 32.1135 37.7836C31.8819 37.928 31.6137 38.0031 31.3408 37.9999Z",
    fill: "#006AB3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1403_1065",
    x: 0,
    y: 0,
    width: 55,
    height: 55.5698,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1403_1065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1403_1065",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderPreviousIcon);
export default __webpack_public_path__ + "static/media/sliderPreviousIcon.b057b75827638b0520416c6bef009323.svg";
export { ForwardRef as ReactComponent };